class OptionSelectedValue extends HTMLElement {
  constructor() {
    super();
    this.optionName = this.getAttribute('data-option-name');
  }

  connectedCallback() {
    // Listen for variant changes
    document.addEventListener('theme:variant:change', this.onVariantChange.bind(this));
  }

  onVariantChange(event) {
    const selectedOptions = event.detail.formState.options;
    if (!selectedOptions.length || !this.optionName) return

    const optionValue = selectedOptions.find(option => option.name === this.optionName)?.value;
    this.textContent = optionValue || '';
  }
}

customElements.define('option-selected-value', OptionSelectedValue); 